import { useQuery } from "@tanstack/react-query";
import { qualifyUrl } from "util/URLUtils";
import ApiRoutes from "routing/ApiRoutes";
import fetch, { fetchPeriodically } from "logic/rest/FetchProvider";
export const TIME_BASED_ROTATION_STRATEGY = "org.graylog2.indexer.rotation.strategies.TimeBasedRotationStrategy";
export const NOOP_RETENTION_STRATEGY = "org.graylog2.indexer.retention.strategies.NoopRetentionStrategy";
export const TIME_BASED_SIZE_OPTIMIZING_ROTATION_STRATEGY = "org.graylog2.indexer.rotation.strategies.TimeBasedSizeOptimizingStrategy";
export const ARCHIVE_RETENTION_STRATEGY = "org.graylog.plugins.archive.indexer.retention.strategies.ArchiveRetentionStrategy";
export const TIME_BASED_SIZE_OPTIMIZING_ROTATION_STRATEGY_TYPE = "org.graylog2.indexer.rotation.strategies.TimeBasedSizeOptimizingStrategyConfig";
export const RETENTION = "retention";
export const INDICES_QUERY_KEY = ["indices"];
export const fetchIndices = (indexSetId) => fetch("GET", qualifyUrl(ApiRoutes.IndicesApiController.list(indexSetId).url));
export const fetchAllIndices = () => fetch("GET", qualifyUrl(ApiRoutes.IndicesApiController.listAll().url));
export const fetchMultipleIndices = (indexNames) => fetchPeriodically("POST", qualifyUrl(ApiRoutes.IndicesApiController.multiple().url), { indices: indexNames });
export const closeIndex = (indexName) => fetch("POST", qualifyUrl(ApiRoutes.IndicesApiController.close(indexName).url));
export const deleteIndex = (indexName) => fetch("DELETE", qualifyUrl(ApiRoutes.IndicesApiController.delete(indexName).url));
export const reopenIndex = (indexName) => fetch("POST", qualifyUrl(ApiRoutes.IndicesApiController.reopen(indexName).url));
export const useIndices = (indexSetId) => useQuery({
  queryKey: [...INDICES_QUERY_KEY, "list", indexSetId],
  queryFn: () => fetchIndices(indexSetId),
  select: (response) => ({
    indices: response.all.indices,
    closedIndices: response.closed.indices
  }),
  enabled: !!indexSetId
});
export const useAllIndices = () => useQuery({
  queryKey: [...INDICES_QUERY_KEY, "listAll"],
  queryFn: fetchAllIndices,
  select: (response) => ({
    indices: response.all.indices,
    closedIndices: response.closed.indices
  })
});
export const useMultipleIndices = (indexNames) => useQuery({
  queryKey: [...INDICES_QUERY_KEY, "multiple", [...indexNames].sort()],
  queryFn: () => fetchMultipleIndices(indexNames),
  enabled: indexNames.length > 0,
  refetchInterval: 5e3
});
